import config from './config';

function getSNatRulesApi(params) {
	return Ajax.get(config.getSNatRules, params);	
}

function getDNatRulesApi(params) {
	return Ajax.get(config.getDNatRules, params);	
}

function getNatPrivateIpsApi(params) {
	return Ajax.get(config.getNatPrivateIps, params);	

}

function getNatEipsApi(params) {
	return Ajax.get(config.getNatEips, params);	
}

function createSNatRulesApi(params) {
	return Ajax.post(config.createSNatRules, params, {
        headers: {
          'Content-Type': 'application/json'
        }
    })	
}

function deleteSNatRuleApi(params) {
	return Ajax.post(config.deleteSNatRule, params, {
        headers: {
          'Content-Type': 'application/json'
        }
    })	
}

function modifySNatRulesApi(params) {
	return Ajax.post(config.modifySNatRules, params, {
        headers: {
          'Content-Type': 'application/json'
        }
    })	
}

function createDNatRuleApi(params) {
	return Ajax.post(config.createDNatRule, params, {
        headers: {
          'Content-Type': 'application/json'
        }
    })	
}

function deleteDNatRuleApi(params) {
	return Ajax.post(config.deleteDNatRule, params, {
        headers: {
          'Content-Type': 'application/json'
        }
    })	
}

function modifyDNatRuleApi(params) {
	return Ajax.post(config.modifyDNatRule, params, {
        headers: {
          'Content-Type': 'application/json'
        }
    })	
}

function describeNatCountByIpApi(params) {
  return Ajax.get(config.describeNatCountByIp, params);	
}
export {
	getSNatRulesApi,
	getDNatRulesApi,
	getNatPrivateIpsApi,
	getNatEipsApi,
	createSNatRulesApi,
	deleteSNatRuleApi,
	modifySNatRulesApi,
	createDNatRuleApi,
  deleteDNatRuleApi,
  modifyDNatRuleApi,
  describeNatCountByIpApi
};


// WEBPACK FOOTER //
// ./src/api/nat/detail/actions.js